import { render, staticRenderFns } from "./DeleteMarketGoods.vue?vue&type=template&id=35ed257a"
import script from "./DeleteMarketGoods.vue?vue&type=script&lang=js"
export * from "./DeleteMarketGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports